import TermsOfServiceScreen from './(onboarding)/terms-of-service';

export default TermsOfServiceScreen;


